import React from "react";
import "../../CSS/ai.css";
import { Link } from "react-router-dom";

function AIBusinessSolutions() {
  return (
    <div className="ai-page">
      
      <section className="ai-hero">
        <div className="container">
          <div className="ai-hero-content">
            <h1>
              AI Solutions <br />
              <span>
                For Your Business
              </span>
            </h1>

            <p>
              Use artificial intelligence to automate processes, improve
              productivity, and create smarter customer experiences.
            </p>
          </div>
        </div>
      </section>


      <section className="ai-service-info-section">
        <div className="container">
          <div className="ai-sections-heading text-center">
            <h2>
              Intelligent Solutions For Modern Businesses
            </h2>
          </div>


          <div className="row g-4 m-4">

            {/* AI Automation */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  ⚙️
                </div>

                <h3>
                  AI Automation
                </h3>

                <p>
                  Identify repetitive business processes and introduce
                  intelligent automation to improve efficiency and save time.
                </p>

              </div>
            </div>


            {/* AI Chatbot */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  💬
                </div>

                <h3>
                  AI Chatbot Solutions
                </h3>

                <p>
                  Intelligent conversational solutions that can help
                  businesses improve customer communication and support.
                </p>

              </div>
            </div>


            {/* AI Assistant */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  🤖
                </div>

                <h3>
                  AI Business Assistants
                </h3>

                <p>
                  AI-assisted tools designed to help teams access
                  information, organize tasks, and improve productivity.
                </p>

              </div>
            </div>


            {/* Document */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  📄
                </div>

                <h3>
                  Document Solutions
                </h3>

                <p>
                  AI-assisted document processing solutions for extracting,
                  organizing, and working with business information.
                </p>

              </div>
            </div>


            {/* Customer Support */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  👥
                </div>

                <h3>
                  Customer Support
                </h3>

                <p>
                  Improve customer experiences with intelligent support
                  workflows and AI-assisted communication solutions.
                </p>

              </div>
            </div>


            {/* Custom AI */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  🚀
                </div>

                <h3>
                  Custom AI Solutions
                </h3>

                <p>
                  Explore customized AI solutions designed around your
                  business processes, requirements, and long-term goals.
                </p>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">

            <div className="cta-content">
              <span className="ai-cta-label">
                START YOUR PROJECT
              </span>
              <h2>
                Want To Explore AI For Your Business?
              </h2>

              <p>
                Tell us about your business requirements and we can
                discuss suitable AI solutions.
              </p>
            </div>

            <Link
              to="/contactus"
              className="cta-button" style={{ textDecoration: 'none' }}
            >
              Discuss Your Requirement
            </Link>

          </div>

        </div>

      </section>


    </div>
  );
}

export default AIBusinessSolutions;